import * as React from "react"
import * as styles from '../styles/social.module.css'

export function OfficialTwitterX(props) {
    const url = "https://twitter.com/" + props.handle
    return (
      <a href={url}>
        <img className={styles.section_sns_official_icon} src="icon/twitter.png" alt="twitterX" />
      </a>
    )
  }
  
  
export function TwitterX(props) {
    const url = "https://twitter.com/" + props.handle
    return (
      <a href={url}>
        <img className={styles.icon} src="icon/twitter.png" alt="twitterX" />
      </a>
    )
  }
  
export function Tumblr(props) {
    const url = "https://"+props.handle+".tumblr.com/"
    return (
      <a href={url}>
        <img className={styles.icon} src="icon/tumblr.png" alt="twitterX"/>
      </a>
    )
  }
  
export function Homepage(props) {
    const url = props.url
    return (
      <a href={url}>
        <img className={styles.icon} src="icon/homepage.png" alt="twitterX"/>
      </a>
    )
  }
  